<template>
    <div :id="element_id" tabindex="-1" role="dialog"
         class="modal fade dc-viewer show"
         style="display: block;"
         aria-hidden="true"
    >
        <div role="document" class="modal-dialog">
            <div class="modal-content">
                <div :class="['overlay-upper', showOverlay ? 'show' : '']">
                    <slot name="back_action" />
                </div>
                <div id="carousel-fs" data-interval="false" data-ride="carousel" class="carousel slide carousel-fade"
                     v-lazy-container="{ selector: 'img', error: '/images/modal_loading.gif', loading: '/images/modal_loading.gif', preLoad: 1 }">
                    <div class="carousel-inner">
                        <div :class="[ 'carousel-item', selected_key == key ? 'active' : '' ]"
                             v-for="(item, key) in media_items"
                             @click="showOverlay = !showOverlay">
                            <img :data-src="item.source" v-if="item.is_image && item.key == current_item.key" :alt="item.name" class="d-block"
                            >
                            <video v-if="item.is_video && item.key == current_item.key" :autoplay="autoplay"
                                   controlsList="nodownload"
                                   loop="loop" muted="muted" controls="controls" class="video-fluid"
                            >
                                <source :src="item.source" type="video/mp4">
                            </video>
                        </div>
                    </div>
                    <a href="#carousel-fs" role="button" data-slide="prev" @click="prevItem" class="carousel-control-prev"><span aria-hidden="true" class="btn-nav prev"></span> <span class="sr-only">{{ trans[locale].previous }}</span></a>
                    <a href="#carousel-fs" role="button" data-slide="next" @click="nextItem" class="carousel-control-next"><span aria-hidden="true" class="btn-nav next"></span> <span class="sr-only">{{ trans[locale].next }}</span></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return Object.assign({
                trans: {
                    'zh-HK': {
                        'next' : 'next',
                        'previous' : 'previous',
                        'album' : '相簿',
                        'category' : '分類',
                        'no_of_viewed' : '觀看次數',
                        'no_of_favourites' : '人',
                    },
                    'en': {
                        'next' : 'next',
                        'previous' : 'previous',
                        'album' : 'Album',
                        'category' : 'Category',
                        'no_of_viewed' : 'Viewing times',
                        'no_of_favourites' : 'Person',
                    },
                },
                media_items: {},
                selected_key: '',
                current_item: {
                    name: '',
                    description: '',
                    download_url: '',
                    album: '',
                    category: '',
                    my_favourite: '',
                    favourite_url: '',
                    view_url: '',
                },
                showOverlay: false,
            },
            { locale: window.locale })
        },
        beforeMount() {
            window.eventHub.$off('prompt-media-modal', this.promptMediaModal);
            document.body.removeEventListener('keyup', (e) => {
                if (e.keyCode == 27) {
                    // Escape
                    this.closeAction();
                }
            });
        },
        mounted() {
            window.eventHub.$on('prompt-media-modal', this.promptMediaModal);
            document.body.addEventListener('keyup', (e) => {
                if (e.keyCode == 27) {
                    // Escape
                    this.closeAction();
                }
            });
        },
        props: {
            element_id: {
                required: true,
                type: String
            },
            with_favourite: {
                required: false,
                type: Boolean,
                default: false
            },
            with_download: {
                required: false,
                type: Boolean,
                default: false
            },
            autoplay: {
                required: false,
                type: Boolean,
                default: false,
            },
            close_action_callback: {
                required: false,
                type: Function,
                default: () => {
                    return null;
                }
            }
        },
        methods: {
            nextItem() {
                let self = this;
                self.selected_key++;
                if (self.selected_key >= _.size(self.media_items))
                {
                    self.selected_key = 0;
                }
                self.current_item = self.media_items[self.selected_key];
            },
            prevItem() {
                let self = this;
                self.selected_key--;
                if (self.selected_key < 0)
                {
                    self.selected_key = _.size(self.media_items) -  1;
                }
                self.current_item = self.media_items[self.selected_key];
            },
            promptMediaModal(param) {
                let self = this;
                self.media_items = param.items;
                _.forEach(param.items, (item, index) => {
                    if (item.key == param.selected_key)
                    {
                        self.selected_key = index;
                        self.current_item = self.media_items[self.selected_key];
                    }
                });
            },
            closeAction() {
                document.body.removeEventListener('keyup', (e) => {
                    if (e.keyCode == 27) {
                        // Escape
                        this.closeAction();
                    }
                });
                this.close_action_callback();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal/MediaModal.vue